import { useMemo } from 'react';

export const useShouldShowFeedbackForms = (
  beforeForm,
  afterForm,
  FeedbackFormBeforeCompleted,
  FeedbackFormAfterCompleted,
  isPreviewPlayer,
  isPublicSession
) => {
  const [beforeSessionForm, afterSessionForm] = useMemo(() => {
    const shouldShowBefore =
      beforeForm?.ID &&
      beforeForm?.ID !== '0' &&
      !isPreviewPlayer &&
      (beforeForm?.AllowMultipleSubmissions ||
        !FeedbackFormBeforeCompleted ||
        isPublicSession);

    const shouldShowAfter =
      afterForm?.ID &&
      afterForm?.ID !== '0' &&
      !isPreviewPlayer &&
      (afterForm?.AllowMultipleSubmissions ||
        !FeedbackFormAfterCompleted ||
        isPublicSession);

    return [shouldShowBefore && beforeForm, shouldShowAfter && afterForm];
  }, [
    FeedbackFormAfterCompleted,
    FeedbackFormBeforeCompleted,
    afterForm,
    beforeForm,
    isPreviewPlayer,
    isPublicSession,
  ]);

  return [beforeSessionForm, afterSessionForm];
};
